import { IRootState } from '@/store/state';
import { ActionContext, ActionTree } from 'vuex';
import { IAssociateUserState } from './state';
import * as AT from './actionTypes';
import * as MT from './mutationTypes';
import {
  PaginatedResult,
  AssociateUser,
  AssociateUsersRequest,
  AddAssociateUserRequest,
  UpdateAssociateUserRequest,
  DeleteAssociateUserRequest
} from '../types';
import { AssociateUserService } from '../services';
import { IAuthActionContext } from '@/modules/auth/store/actions';
import { SET_LOADER } from '../../organisation/store/mutationTypes';
/**
 * --------------------------------------------------
 *  User Actions
 * --------------------------------------------------
 **/
export const AssociateUserActions: IUserActions = {
  [AT.FETCH_ASSOCIATE_USERS]: (
    { commit },
    associateUsersRequest: AssociateUsersRequest
  ): Promise<AssociateUser[]> => {
    commit(SET_LOADER, true);
    return AssociateUserService.getAssociateUsers(associateUsersRequest).then(
      (paginatedResult: PaginatedResult) => {
        commit(MT.SET_PAGINATION_META, paginatedResult.meta);
        commit(MT.SET_ASSOCIATE_USERS, paginatedResult.data);
        commit(SET_LOADER, false);
        return paginatedResult.data;
      }
    );
  },
  [AT.ADD_ASSOCIATE_USER]: (
    { commit },
    addAssociateUserRequest: AddAssociateUserRequest
  ): Promise<Response> => {
    commit(SET_LOADER, true);
    return AssociateUserService.postAssociateUsers(
      addAssociateUserRequest
    ).then((data: Response) => data);
  },
  [AT.EDIT_ASSOCIATE_USER]: (
    { commit },
    editAssociateUserRequest: UpdateAssociateUserRequest
  ): Promise<Response> => {
    commit(SET_LOADER, true);
    return AssociateUserService.putAssociateUsers(
      editAssociateUserRequest
    ).then((data: Response) => data);
  },
  [AT.DELETE_ASSOCIATE_USER]: (
    { commit },
    deleteAssociateUserRequest: DeleteAssociateUserRequest
  ): Promise<Response> => {
    commit(SET_LOADER, true);
    return AssociateUserService.deleteAssociateUsers(
      deleteAssociateUserRequest
    ).then((data: Response) => data);
  }
};

/**
 * --------------------------------------------------
 *  User Action Context Interface
 * --------------------------------------------------
 **/
export interface IAssociateUserActionContext
  extends ActionContext<IAssociateUserState, IRootState> {}

/**
 * --------------------------------------------------
 *  User Actions Interface
 * --------------------------------------------------
 **/
export interface IUserActions
  extends ActionTree<IAssociateUserState, IRootState> {
  [AT.FETCH_ASSOCIATE_USERS](
    context: IAssociateUserActionContext,
    orgUsersRequest: AssociateUsersRequest
  ): Promise<AssociateUser[]>;
  [AT.ADD_ASSOCIATE_USER](
    context: IAssociateUserActionContext,
    addAssociateUserRequest: AddAssociateUserRequest
  ): Promise<Response>;
  [AT.EDIT_ASSOCIATE_USER](
    context: IAssociateUserActionContext,
    editAssociateUserRequest: UpdateAssociateUserRequest
  ): Promise<Response>;
  [AT.DELETE_ASSOCIATE_USER](
    context: IAssociateUserActionContext,
    deleteAssociateUserRequest: DeleteAssociateUserRequest
  ): Promise<Response>;
}
